import { useRef, useEffect, useCallback } from 'react';
import { trackLanding, trackExit, buildLandingTrackingData } from 'ai/analytics/trackers/pageTrackers';
import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';

let landingTrackedForCurrentSession = false;

const useSuperChatAnalytics = ({ initialEntryPointData, isChatInitialized }) => {
    const selectedPromptRef = useRef(null);
    const sourceRef = useRef(null);
    const internalCampaignRef = useRef(null);

    useEffect(() => {
        if (initialEntryPointData?.selectedPrompt && !selectedPromptRef.current) {
            selectedPromptRef.current = initialEntryPointData.selectedPrompt;
        }

        if (initialEntryPointData?.source && !sourceRef.current) {
            sourceRef.current = initialEntryPointData.source;
        }

        if (initialEntryPointData?.internalCampaign && !internalCampaignRef.current) {
            internalCampaignRef.current = initialEntryPointData.internalCampaign;
        }
    }, [initialEntryPointData]);

    useEffect(() => {
        if (isChatInitialized && !landingTrackedForCurrentSession) {
            landingTrackedForCurrentSession = true;
            const trackingData = buildLandingTrackingData(sourceRef.current, selectedPromptRef.current);

            if (trackingData.actionInfo) {
                trackingData.linkData = trackingData.actionInfo;
            }

            if (internalCampaignRef.current) {
                trackingData.internalCampaign = internalCampaignRef.current;
            }

            processEvent.process(anaConsts.ASYNC_PAGE_LOAD, { data: trackingData });
        }

        return () => {
            landingTrackedForCurrentSession = false;
        };
    }, [isChatInitialized]);

    const sendExitAnalytics = useCallback(() => {
        landingTrackedForCurrentSession = false;
        trackExit();
    }, []);

    return {
        sendExitAnalytics,
        trackLanding
    };
};

export default useSuperChatAnalytics;
